import { Link } from 'react-router-dom';
import { Cartao } from '../componentes/Cartao.js';
import { EstadoVazio } from '../componentes/EstadoVazio.js';
import { IconeBusca } from '../componentes/Icones.js';
import { Pagina } from '../componentes/Pagina.js';
import './NaoEncontrada.css';

export function NaoEncontrada() {
  return (
    <Pagina contexto="Painel" titulo="Página não encontrada">
      <Cartao semRespiro>
        <EstadoVazio
          tom="neutro"
          icone={<IconeBusca tamanho={28} />}
          titulo="O endereço acessado não existe no painel."
          detalhe="Verifique o link ou volte para a visão geral."
        />
        <p className="nao-encontrada__acao">
          <Link to="/visao-geral">Voltar à visão geral</Link>
        </p>
      </Cartao>
    </Pagina>
  );
}
